<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirmAnimalManureTransportFetch()"
  (cancel)="cancel()"
  #ngForm="ngForm"
>
  <div class="dialog spacing--margin-top">
    <h1>{{ 'animalManureTransport.datepickerDialogLabel' | translate }}</h1>
    <div class="flex--row flex--gutter">
      <mat-form-field
        class="full-width-field flex__child--auto"
        data-test="fetch-animal-manure-transports-dialog-kvk-number"
      >
        <mat-label>{{ 'kvkNumber' | translate }}</mat-label>
        <input matInput formControlName="kvkNumber" />
      </mat-form-field>
      <mat-form-field class="full-width-field flex__child--auto">
        <mat-label>{{ 'animalManureTransport.defaultSoilTypeVDM' | translate }}</mat-label>
        <mat-select
          formControlName="defaultSoilTypeId"
          [placeholder]="'animalManureTransport.defaultSoilTypeVDM' | translate"
          data-test="editTreatment-defaultSoilTypeVDM"
        >
          @for (soilType of soilTypes; track soilType) {
            <mat-option [value]="soilType.id"> {{ soilType.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field
        class="flex__child--auto"
        data-test="fetch-animal-manure-transports-dialog-start-date"
      >
        <mat-label>{{ 'from' | translate }}</mat-label>
        <input
          matInput
          formControlName="startDate"
          [matDatepicker]="fromDatePicker"
          [min]="startMinDate"
          [max]="startMaxDate"
          [placeholder]="'from' | translate"
        />
        <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #fromDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field
        class="flex__child--auto"
        data-test="fetch-animal-manure-transports-dialog-end-date"
      >
        <mat-label>{{ 'until' | translate }}</mat-label>
        <input
          matInput
          formControlName="endDate"
          [matDatepicker]="untilDatePicker"
          [min]="endMinDate"
          [max]="endMaxDate"
          [placeholder]="'until' | translate"
        />
        <mat-datepicker-toggle matSuffix [for]="untilDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #untilDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</agr-form-dialog>
